import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import TimePicker from 'antd/es/time-picker';
import 'antd/es/time-picker/style/index.css';
import {
    DateInput
} from 'semantic-ui-calendar-react';
import Select from "antd/es/select";
import "antd/es/select/style/index.css";
import moment from 'moment';
import 'moment/locale/vi';
import './styles.scss';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import _ from 'lodash';
import functionCommon from '../../core/common/function';

class WorkingHourForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errInputMsg: {},
            date: moment().format('DD-MM-YYYY'),
            businessFrom: "",
            businessTo: ""
        }
    }

    changeDate = (event, { name, value }) => {
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }
        this.setState({
            businessFrom: "",
            businessTo: ""
        });
        this.props.searchWorklog(moment(value, 'DDMMYYYY').format('YYYY-MM-DD'));
    }

    setBusinessFrom = (time, timeString) => {
        this.props.changeBusinessTime("businessFrom", timeString);
        this.state.errInputMsg['businessFrom'] = ''
    }

    setBusinessTo = (time, timeString) => {
        this.props.changeBusinessTime("businessTo", timeString);
        this.state.errInputMsg['businessFrom'] = ''
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError
        });
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    }

    onChangeProject = (value ) => {
        this.props.changeAutoComplete({_name: "projectId", _value: value});
    }

    onChangeApprover = (value ) => {
        this.props.changeAutoComplete({_name: "approverId", _value: value});
    }
    employeeProcess = (rawData) => {
        if (rawData && rawData.length > 0) {
            console.log(rawData);
            const employee = rawData.map((ele) => {
                return {
                    value: ele.id,
                    name: ele.employeeCode + " - " + ele.employeeName,
                }
            });
            return employee;
        } else return [];
    }

    render() {
        const {
            worklogData, totalOtOfMonth,
            dataProject, dataApprover,
            changeWorkLog, t
        } = this.props;
        const _dataProject = _.map(dataProject, (state, index) => ({
            key: "project-" + index + 1,
            text: state['projectCode'] + ' - ' + state['projectName'],
            value: state['id'],
        }));
        _dataProject.unshift({
            key: "project-0",
            text: 'All',
            value: '',
        });
        const _dataApprover = this.employeeProcess(dataApprover)
        const { Option } = Select;
        const overtimeTypeOps = [
            {
                value: '0',
                text: t('overtimeType.0')
            },
            {
                value: '6',
                text: t('overtimeType.6')
            },
            {
                value: '3',
                text: t('overtimeType.3')
            },
            {
                value: '1',
                text: t('overtimeType.1')
            },
            {
                value: '2',
                text: t('overtimeType.2')
            },
            {
                value: '4',
                text: t('overtimeType.4')
            },
            {
                value: '5',
                text: t('overtimeType.5')
            },
            {
                value: '7',
                text: t('overtimeType.7')
            }
        ];
        const shiftOps = [
            {
                value: '0',
                text: t('shift.0')
            },
            {
                value: '1',
                text: t('shift.1')
            },
            {
                value: '2',
                text: t('shift.2')
            }
        ]
        return (
            <div className="employee-form">
                <Form autoComplete="off">
                    <Form.Group inline className="form-required">
                        <label>{t('labels.project')}</label>
                        <Select
                            name="projectId"
                            onChange={this.onChangeProject}
                            style={{ width: 196 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={parseInt(worklogData.projectId) || ''}
                        >
                            {(_dataProject)
                                ? _dataProject.map((item, index)=> 
                                    <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                                )
                                : ''
                            }
                        </Select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['projectId'])}</div>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.workingHour')}</label>
                        <Form.Input
                            name="normalTime"
                            value={worklogData.normalTime || ''}
                            onChange={changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['normalTime'])}</div>
                    <Form.Group inline>
                        <label>{t('labels.overtime')} 1</label>
                        <Form.Input
                            name="overtime-1"
                            value={worklogData['overtime-1'] || ''}
                            onChange={changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['overtime-1'], {type: 1})}</div>
                    <Form.Group inline>
                        <label>{t('labels.overtimeType')} 1</label>
                        <select name="overtimeType-1"
                            value={worklogData['overtimeType-1']}
                            onChange={changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(overtimeTypeOps)
                                ? overtimeTypeOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['overtimeType-1'], {type: 1})}</div>
                    <Form.Group inline>
                        <label>{t('labels.overtime')} 2</label>
                        <Form.Input
                            name="overtime-2"
                            value={worklogData['overtime-2'] || ''}
                            onChange={changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['overtime-2'], {type: 2})}</div>
                    <Form.Group inline>
                        <label>{t('labels.overtimeType')} 2</label>
                        <select name="overtimeType-2"
                            value={worklogData['overtimeType-2']}
                            onChange={changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(overtimeTypeOps)
                                ? overtimeTypeOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['overtimeType-2'], {type: 2})}</div>
                    <Form.Group inline>
                        <label>{t('labels.overtime')} 3</label>
                        <Form.Input
                            name="overtime-3"
                            value={worklogData['overtime-3'] || ''}
                            onChange={changeWorkLog.bind(this)}
                            maxLength="4" />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['overtime-3'], {type: 3})}</div>
                    <Form.Group inline>
                        <label>{t('labels.overtimeType')} 3</label>
                        <select name="overtimeType-3"
                            value={worklogData['overtimeType-3']}
                            onChange={changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(overtimeTypeOps)
                                ? overtimeTypeOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['overtimeType-3'], {type: 3})}</div>
                    
                    <Form.Group inline>
                        <label>{t('labels.totalOtMonth')}: <span className="total-ot">{totalOtOfMonth || 0}</span></label>
                    </Form.Group>
                    
                    {(this.props.isSpecialProject.toLowerCase().indexOf("special leave") > -1)
                    ? <Form.Group inline>
                        <p className="special-message" dangerouslySetInnerHTML={{__html: t('message.501')}}></p>
                    </Form.Group>
                    : ''}
                </Form>
                <Form className="date-time-picker" autoComplete="off">
                    <Form.Group inline className="date-input">
                        <label></label>
                        <DateInput
                            className="date-picker"
                            name="date"
                            placeholder="DD-MM-YYYY"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD-MM-YYYY"
                            value={this.state.date}
                            onChange={this.changeDate}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={this.handleKeyDown}
                        />
                    </Form.Group>
                    <div className='wrapper-select'>
                    <Form.Group inline>
                        <label>{t('labels.approver')}</label>
                        <Select
                            name="approverId"
                            onChange={this.onChangeApprover}
                            style={{ width: 257 }}
                            showSearch
                            filterOption={functionCommon.filterEmployee}
                            value={parseInt(worklogData.approverId) || ''}
                        >
                            <Option value="" label="">&nbsp;</Option>
                            {(_dataApprover)
                                ? _dataApprover.map((item, index)=> 
                                    <Option value={item.value} key={index} label={item.name}>{item.name}</Option>
                                )
                                : ''
                            }
                        </Select>
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t('labels.shift')}</label>
                        <select name="shift"
                            style={{ width: 257 , maxWidth: 257}}
                            value={worklogData.shift}
                            onChange={changeWorkLog.bind(this)}>
                            <option value="">&nbsp;</option>
                            {(shiftOps)
                                ? shiftOps.map((option, index) => {
                                    return (
                                        <option value={option.value} key={index}>{option.text}</option>
                                    )
                                })
                                : ''
                            }
                        </select>
                    </Form.Group>
                    <Form.Group inline className="time-input">
                        <label>{t('labels.businessFrom')}</label>
                        <TimePicker 
                            className="business-from-input"
                            inputReadOnly={true} 
                            format="HH:mm"
                            onChange={this.setBusinessFrom}
                            value={(worklogData.businessFrom) ? moment(worklogData.businessFrom, "HH:mm"): null}
                            minuteStep={5}
                            placeholder={""}/>
                        <label>{t('labels.to')}</label>
                        <TimePicker 
                            inputReadOnly={true} 
                            format="HH:mm"
                            onChange={this.setBusinessTo}
                            value={(worklogData.businessTo) ? moment(worklogData.businessTo, "HH:mm"): null}
                            minuteStep={5}
                            placeholder={""}/>
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['businessFrom'])}</div>
                    <Form.Group inline className="site-checkbox">
                        <label>{t('labels.site')}</label>
                        <Form.Field>
                            <input type="checkbox" name="site" className="invisible"
                                id="on-site"
                                value={worklogData.site}
                                checked={worklogData.site === true ? true : false}
                                onChange={changeWorkLog.bind(this)} />
                            <label htmlFor="on-site" className="checkbox-label no-text">{t('labels.site')}</label>
                        </Form.Field>
                    </Form.Group>
                    <Form.Group inline className="remark-input">
                        <label>{t('labels.remark')}</label>
                        <textarea
                            name="remark"
                            value={worklogData.remark}
                            onChange={changeWorkLog.bind(this)}
                            rows="3"></textarea>
                    </Form.Group>
                    <Form.Group></Form.Group>
                    </div> 
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(WorkingHourForm);
